module.exports = __webpack_public_path__ + "img/header.fbbf625c.jpg";